export default __webpack_public_path__ + "static/media/ali.45593dc3.pdf";